var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { attrs: { id: "classCreate" } },
        [
          _c(
            "v-card",
            { attrs: { "max-width": "800px" } },
            [
              _c("v-card-title", [_vm._v(_vm._s(_vm.title))]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "integrationForm",
                      model: {
                        value: _vm.valid,
                        callback: function($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid"
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("integrations.edit.fields.name.title"),
                          required: _vm.required,
                          rules: [_vm.rules.required],
                          compact: "",
                          hint: _vm.$t("integrations.edit.fields.name.hint")
                        },
                        model: {
                          value: _vm.integration.name,
                          callback: function($$v) {
                            _vm.$set(_vm.integration, "name", $$v)
                          },
                          expression: "integration.name"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t(
                            "integrations.edit.fields.redirectUrl.title"
                          ),
                          required: _vm.required,
                          rules: [_vm.rules.required],
                          compact: "",
                          hint: _vm.$t(
                            "integrations.edit.fields.redirectUrl.hint"
                          )
                        },
                        model: {
                          value: _vm.integration.redirectUrl,
                          callback: function($$v) {
                            _vm.$set(_vm.integration, "redirectUrl", $$v)
                          },
                          expression: "integration.redirectUrl"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: "LMS URL",
                          required: _vm.required,
                          rules: [_vm.rules.required],
                          compact: "",
                          hint: ""
                        },
                        model: {
                          value: _vm.integrationLti.consumerUrl,
                          callback: function($$v) {
                            _vm.$set(_vm.integrationLti, "consumerUrl", $$v)
                          },
                          expression: "integrationLti.consumerUrl"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: "Name",
                          required: _vm.required,
                          rules: [_vm.rules.required],
                          compact: "",
                          hint: ""
                        },
                        model: {
                          value: _vm.integrationLti.consumerName,
                          callback: function($$v) {
                            _vm.$set(_vm.integrationLti, "consumerName", $$v)
                          },
                          expression: "integrationLti.consumerName"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: "Client ID",
                          required: _vm.required,
                          rules: [_vm.rules.required],
                          compact: "",
                          hint: ""
                        },
                        model: {
                          value: _vm.integrationLti.consumerToolClientID,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.integrationLti,
                              "consumerToolClientID",
                              $$v
                            )
                          },
                          expression: "integrationLti.consumerToolClientID"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: "Auth URL",
                          required: _vm.required,
                          rules: [_vm.rules.required],
                          compact: "",
                          hint: ""
                        },
                        model: {
                          value: _vm.integrationLti.consumerAuthorizationURL,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.integrationLti,
                              "consumerAuthorizationURL",
                              $$v
                            )
                          },
                          expression: "integrationLti.consumerAuthorizationURL"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: "Token URL",
                          required: _vm.required,
                          rules: [_vm.rules.required],
                          compact: "",
                          hint: ""
                        },
                        model: {
                          value: _vm.integrationLti.consumerAccessTokenURL,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.integrationLti,
                              "consumerAccessTokenURL",
                              $$v
                            )
                          },
                          expression: "integrationLti.consumerAccessTokenURL"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: "Cert URL",
                          required: _vm.required,
                          rules: [_vm.rules.required],
                          compact: "",
                          hint: ""
                        },
                        model: {
                          value: _vm.consumerAuthorizationconfig.key,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.consumerAuthorizationconfig,
                              "key",
                              $$v
                            )
                          },
                          expression: "consumerAuthorizationconfig.key"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-card-text", [
                !_vm.valid
                  ? _c("div", [
                      _c("span", { staticClass: "validateError" }, [
                        _vm._v(_vm._s(_vm.$t("integrationEdit.validate-info")))
                      ])
                    ])
                  : _vm._e()
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1" },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { disabled: !_vm.valid, color: "success" },
                      on: { click: _vm.validate }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("global.save")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }